import { render } from "./ScreenTextsGreen.vue?vue&type=template&id=545aef14&ts=true"
import script from "./ScreenTextsGreen.vue?vue&type=script&lang=ts"
export * from "./ScreenTextsGreen.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__